import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ className = '' }) => {
  return (
    <Link to="/" className={`flex items-center gap-3 font-bold font-display ${className}`}>
      <img 
        src={`${process.env.PUBLIC_URL}/images/logo.png`} 
        alt="Social Crouton Logo" 
        className="w-14 h-14 md:w-16 md:h-16 object-contain"
      />
      <span className="text-2xl md:text-3xl">
        <span className="text-[#D9A566]">Social</span><span className="text-[#C45D4C]">Crouton</span>
      </span>
    </Link>
  );
};

export default Logo;